<div class="product-plan-card" [ngClass]="{'product-plan-card--dark': productPlanCard === MainCardTypes.SmartTag}">
  <div class="product-plan-card__image">
    <img [src]="backgroundImage" alt="{{ title }}" [style.object-position]="imagePosition"/>
    <span class="product-plan-card__tag" *ngIf="tag">{{ tag }}</span>
  </div>

  <div class="product-plan-card__body">
    <div class="product-plan-card__title-row">
        <h1 class="product-plan-card__title">{{ title }}</h1>
        <span class="product-plan-card__badge" *ngIf="badge">{{ badge }}</span>
    </div>
    <p class="product-plan-card__subtitle">{{ subtitleText }}</p>

    <ul class="product-plan-card__features">
      <li *ngFor="let feature of features">
        <span class="check-icon">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12"
              cy="12"
              r="12"
              [attr.fill]="isPremiumProductType ? '#ff6b35' : '#F4A58A'"
               />
            <path d="M6 12.5L10 16.5L18 8"
             [attr.stroke]="isPremiumProductType ? 'black' : 'white'"  
             stroke-width="2.5" 
             stroke-linecap="round" 
             stroke-linejoin="round"/>
          </svg>
        </span>
        {{ feature }}
      </li>
    </ul>

    <div class="product-plan-card__footer">
      <span class="product-plan-card__price">
        <strong>{{ price }}</strong><span>/yr</span>
      </span>
      <button
        class="btn"
        [ngClass]="isPremiumProductType ? 'btn-alert' : 'btn-smart-tag'"
        type="button"
        (click)="onBuyNow(isPremiumProductType)"
        [disabled]="disabled"
      >
        Buy Now
      </button>
    </div>
  </div>
</div>